import { Component, input, output } from '@angular/core';
import { OnboardingStep } from '../../../shared/models/onboarding.model';

@Component({
  standalone: false,
  selector: 'app-onboarding-step',
  templateUrl: './onboarding-step.component.html',
  styleUrl: '../onboarding.component.scss',
})
export class OnboardingStepComponent {
  readonly step = input.required<OnboardingStep>();
  readonly index = input<number | null>(null);
  readonly stepSelect = output<OnboardingStep>();
}
